import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import styled from 'styled-components';
var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-2rg9le"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 32px 24px;\n  \n  &.paddingLarge {\n    padding: 0 48px 48px 48px;\n  }\n  &.spacing > * + * {\n    margin-left: 8px;\n  }\n  &.alignLeft {\n    justify-content: flex-start;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 32px 24px;\n  \n  &.paddingLarge {\n    padding: 0 48px 48px 48px;\n  }\n  &.spacing > * + * {\n    margin-left: 8px;\n  }\n  &.alignLeft {\n    justify-content: flex-start;\n  }\n"])));
var DialogActions = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      _b = _a.align,
      align = _b === void 0 ? 'right' : _b,
      _c = _a.paddingSize,
      paddingSize = _c === void 0 ? 'normal' : _c,
      disableSpacing = _a.disableSpacing,
      otherProps = __rest(_a, ["className", "align", "paddingSize", "disableSpacing"]);

  var rootClassName = classnames({
    spacing: !disableSpacing
  }, "align".concat(capitalize(align)), "padding".concat(capitalize(paddingSize)), className);
  return _jsx(Root, __assign({
    className: rootClassName,
    ref: ref
  }, otherProps));
});
export default React.memo(DialogActions);
var templateObject_1;